import { SxProps, Theme, Box, styled } from '@mui/material';
import React, { ReactNode } from 'react';
import styles from './Circle6.module.scss';

type Circle6Props = {
    children?: ReactNode | undefined,
    sx?: SxProps<Theme>,
    className?: string,
};

const Circle6Layout = styled(Box)(({ theme }) => ({

}));

const Circle6 = (props: Circle6Props) => {
    const { sx, className } = props;

    return (
        <Circle6Layout className={`${styles.Circle6} ${className || ""}`} sx={sx} data-testid="Circle6" data-aos="zoom-in" />
    );
};

export default Circle6;
